import React from "react";
import { Card, Row, Col, Input, Select, Button, Space } from "antd";
import { SearchOutlined, ClearOutlined, FilterOutlined } from "@ant-design/icons";

const { Option } = Select;

const FilterPanel = ({ filters, setFilters }) => {
  const handleChange = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleClear = () => {
    setFilters({
      search: "",
      action: null,
      method: null,
      status: null,
    });
  };

  return (
    <Card 
      bordered={false}
      style={{ 
        borderRadius: 12,
        boxShadow: "0 1px 2px rgba(0,0,0,0.03)"
      }}
    >
      <Row gutter={[16, 16]} align="middle">
        <Col xs={24} lg={6}>
          <Input
            placeholder="Search user or endpoint..."
            prefix={<SearchOutlined style={{ color: "#bfbfbf" }} />}
            value={filters.search}
            onChange={(e) => handleChange("search", e.target.value)}
            allowClear
            size="large"
            style={{ borderRadius: 8 }}
          />
        </Col>

        <Col xs={24} sm={8} lg={5}>
          <Select
            placeholder="Filter by Action"
            value={filters.action}
            onChange={(value) => handleChange("action", value)}
            allowClear
            style={{ width: "100%" }}
            size="large"
            dropdownStyle={{ borderRadius: 8 }}
          >
            <Option value="CREATE">CREATE</Option>
            <Option value="UPDATE">UPDATE</Option>
            <Option value="DELETE">DELETE</Option>
            <Option value="LOGIN">LOGIN</Option>
            <Option value="LOGOUT">LOGOUT</Option>
            <Option value="IMPERSONATE">IMPERSONATE</Option>
          </Select>
        </Col>

        <Col xs={24} sm={8} lg={4}>
          <Select
            placeholder="HTTP Method"
            value={filters.method}
            onChange={(value) => handleChange("method", value)}
            allowClear
            style={{ width: "100%" }}
            size="large"
          >
            <Option value="GET">GET</Option>
            <Option value="POST">POST</Option>
            <Option value="PUT">PUT</Option>
            <Option value="PATCH">PATCH</Option>
            <Option value="DELETE">DELETE</Option>
          </Select>
        </Col>

        <Col xs={24} sm={8} lg={4}>
          <Select
            placeholder="Status"
            value={filters.status}
            onChange={(value) => handleChange("status", value)}
            allowClear
            style={{ width: "100%" }}
            size="large"
          >
            <Option value="2xx">2xx Success</Option>
            <Option value="4xx">4xx Client Error</Option>
            <Option value="5xx">5xx Server Error</Option>
          </Select>
        </Col>

        <Col xs={24} lg={5}>
          <Space size="middle">
            <Button
              icon={<FilterOutlined />}
              type="primary"
              size="large"
              style={{ borderRadius: 8 }}
            >
              Apply Filters
            </Button>
            <Button
              icon={<ClearOutlined />}
              onClick={handleClear}
              size="large"
              style={{ borderRadius: 8 }}
            >
              Clear
            </Button>
          </Space>
        </Col>
      </Row>
    </Card>
  );
};

export default FilterPanel;